import { Car } from "@/models/base";

export class SaleEditStateCarSelectData {
	public isOpen:boolean = false;
	public car:Car | null = null;
	public mileage:number = 0;
}